/**
 * Created by will on 6/30/14.
 */
var firstRun = angular.module('firstRun', ['classy', 'firstRunModel', 'firstRunTrackingModel']);
firstRun.classy.controller({
    name: 'FirstRunController',
    inject: ['$scope', 'FirstRunModelService', 'div', '$modalInstance', 'SchoolModelService',
        'authServiceFactory', 'FirstRunTrackingModelService'],
    init: function () {
        this.$.currentDiv = this.div;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.currentMonth = '';
        switch (this.$.schoolinfo.Year_End) {
            case 1:
                this.$.currentMonth = "January";
                break;
            case 2:
                this.$.currentMonth = "February";
                break;
            case 3:
                this.$.currentMonth = "March";
                break;
            case 4:
                this.$.currentMonth = "April";
                break;
            case 5:
                this.$.currentMonth = "May";
                break;
            case 6:
                this.$.currentMonth = "June";
                break;
            case 7:
                this.$.currentMonth = "July";
                break;
            case 8:
                this.$.currentMonth = "August";
                break;
            case 9:
                this.$.currentMonth = "September";
                break;
            case 10:
                this.$.currentMonth = "October";
                break;
            case 11:
                this.$.currentMonth = "November";
                break;
            case 12:
                this.$.currentMonth = "December";
                break;
        }

        this.$.page = 0;
    },
    hideMessage: function()
    {
        this.put("0000-00-00");
    },
    remindMeLater: function()
    {
        var now = new Date();
        now.setDate(now.getDate() + 2);
        this.put(now.getDateMySqlFormatted());
    },
    put: function(date)
    {
        var data =
        {
            dateShowNext: date,
            recordID: this.FirstRunModelService.get()[this.index].recordID
        };
        var parent = this;
        this.FirstRunTrackingModelService.put(this.authServiceFactory.getAuth().schoolID, data).then(function() {
            parent.$modalInstance.dismiss();
        });
    },
    nextPage: function(num)
    {
        if (num==undefined)
            this.$.page++;
        else
            this.$.page = num;
    },
    prevPage: function()
    {
        this.$.page--;  
    },
    getCurrentPage: function()
    {
        return "fast/submodules/schoolside/firstRun/newFinAidYear/page" + this.$.page + ".html";
    }

});


firstRun.service('FirstRunModalService', function($modal, FirstRunModelService, authServiceFactory){

    var result = {}
    result.initModal = function(div)
    {
        return $modal.open({
            templateUrl: "fast/submodules/schoolside/firstRun/firstRun.html?v=" + versionNo,
            controller: "FirstRunController",
            resolve:
            {
                div: function() { return div; }
            },
            backdrop: 'static',
            keyboard: false

        });
    }

    result.fireFirstRun = function(name)
    {
        if (name == "newFinAidYear" && authServiceFactory.getAuth().yearChangeOver)
        {
            result.initModal(name);
        }

        /*
        var today = new Date().getDateMySqlFormatted().replaceAll("-", "")
        for (var i = 0; i < FirstRunModelService.get().length; i++)
        {
            if (FirstRunModelService.get()[i].name == name)
            {
                var showNext = FirstRunModelService.get()[i].dateShowNext.replaceAll("-", "");
                if (today >= showNext && showNext != '00000000')
                {
                    result.initModal(i);
                    return false;
                }

            }
        }
        */
    }
    return result;
});